class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    if (this.sliderItems.length === 0) return;
    
    // Get the total products from the counter element that's set in the liquid template
    const totalProducts = parseInt(this.pageTotal.textContent);
    
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = Math.ceil(this.sliderItems.length / this.slidesPerPage);
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;

    const scrollPosition = this.slider.scrollLeft;
    const itemWidth = this.sliderItems[0].clientWidth;
    const totalItems = parseInt(this.pageTotal.textContent);

    // Calculate which product is currently "selected" based on scroll position
    let currentProductIndex = Math.floor(scrollPosition / itemWidth);
    
    // Add a buffer for the last group of products
    // If we're at or near the end of the scroll, show the last product number
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    if (scrollPosition + 1 >= maxScroll) { // Adding 1 to handle minor decimal differences
      currentProductIndex = totalItems - 1;
    }

    // Add 1 for human-readable position (1-based instead of 0-based)
    const currentProduct = Math.min(currentProductIndex + 1, totalItems);

    this.prevButton.disabled = currentProduct === 1;
    this.nextButton.disabled = currentProduct === totalItems;

    this.pageCount.textContent = currentProduct;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' 
      ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
      : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'smooth'
    });
  }
}

customElements.define('slider-component', SliderComponent);
